import { render, staticRenderFns } from "./IconAddress.vue?vue&type=template&id=3f21555b&"
import script from "./IconAddress.vue?vue&type=script&lang=js&"
export * from "./IconAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports